
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import Vue from 'vue'
import OnlineService from '@/services/OnlineService'
import JWTUtils from '@/utils/JWTUtils'
import { RegisterUserRequest } from '@/types/api'

export default Vue.extend({
  name: 'SignUpCallBack',
  created () {
    this.$store.dispatch('clearLogin')
    this.$store.commit('isLoading', true)
    this.$store.commit('isLoadingForce', true)
    const params: RegisterUserRequest = {
      companyId: process.env.VUE_APP_COMPANY_ID,
      state: this.$route.query.state as string,
      code: this.$route.query.code as string
    }
    OnlineService.registerUser(params).then(data => {
      const jwtToken = JWTUtils.extract(data)
      JWTUtils.save(jwtToken)
      this.$store.commit('jwt', jwtToken)
      this.$store.commit('isLoading', false)
      this.$store.commit('isLoadingForce', false)
      this.$router.push({
        name: data.changeDepartmentConfirm ? 'changeDepartmentConfirm' : 'upload'
      })
    })
  }
})
